import React from 'react';
import { ErrorWrapper } from './ProductPackageAdderRoot/styles';
import Alert, { AlertTitle } from '../reusable/Alert';
import { IconInfoCircle } from '@tabler/icons-react';
import useTranslate, { DefaultMessagesKeys } from '@src/i18n/useTranslate';

interface Props {
  error?: string;
}

const ProductPackageAdderError = (props: Readonly<Props>) => {
  const { i18n } = useTranslate();
  const { error } = props;

  if (!error) return null;

  return (
    <ErrorWrapper>
      <Alert severity='error' variant='ghost' icon={<IconInfoCircle size={24} />}>
        <AlertTitle>{i18n(error as DefaultMessagesKeys)}</AlertTitle>
      </Alert>
    </ErrorWrapper>
  );
};

export default ProductPackageAdderError;
